export default __webpack_public_path__ + "static/media/a009-tip1.84fb2f2b.jpg";